import httpClient from '@/api/httpClient';

const fetchInvestmentStrategyRecommendedBasedOnRiskTolerance = params => {
    return httpClient.get('/risk-tolerance', { params })
        .then(({ data }) => {
            return data;
        });
};

export default {
    fetchInvestmentStrategyRecommendedBasedOnRiskTolerance,
};
